import { Typography, Grid, Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(0.25),
  },
  occupationItem: {
    marginBottom: theme.spacing(0.25),
    padding: theme.spacing(0.25),
  },
  function: {
    fontWeight: 600,
    marginRight: theme.spacing(0.25),
  },
  profiles: {
    fontSize: "0.875rem",
  },
}));

const SubHeaderDetails = ({ details }) => {
  const classes = useStyles();
  
  return (
    <Box className={classes.root}>
      {Object.keys(details).map((func, idx) => {
        if (!details[func]) return <></>;
        return (<Grid key={idx} className={classes.occupationItem}>
          <Typography className={classes.profiles}>
            {func && <span className={classes.function}>{`${func}:`}</span>}
            {details[func] && details[func].join(", ")}
          </Typography>
        </Grid>)
      })}
    </Box>
  );
};

export default SubHeaderDetails;
